import { useEffect, useState, useContext } from "react";
import MessageServices from "../services/messageServices";
import { AuthContext } from '../contexts/AuthContext';

export default function useMessage(discussionId) {
    const { api } = useContext(AuthContext);
    //   const [messages, setMessages] = useState([]);
    //   const currentUser = JSON.parse(localStorage.getItem("user"));
    //   let unreadCount = 0;
    const service = new MessageServices(api);

    //   const incrementTabBadge = () => {
    //     unreadCount++;
    //     document.title = `(${unreadCount}) Nouveau message`;
    //   };

    //   const resetTabBadge = () => {
    //     unreadCount = 0;
    //     document.title = "Message";
    //   };

    //   const showPush = (data) => {
    //     if (Notification.permission !== "granted") {
    //       console.warn("Notification non autorisée");
    //       return;
    //     }

    //     new Notification("Nouveau message Deal.mg", {
    //       body: data.message,
    //       icon: "/logo.png",
    //     });
    //   };

    //   const loadMessages = async () => {
    //     if (!discussionId) return;
    //     try {
    //       const res = await service.getByDiscussion(discussionId);
    //       setMessages(res.data.data || []);
    //     } catch (err) {
    //       console.error("Erreur chargement messages:", err);
    //     }
    //   };

    //   useEffect(() => {
    //     if (!discussionId) return;
    //     socket.connect();
    //     socket.emit("joinDiscussion", discussionId);
    //     socket.emit("joinUserRoom", currentUser._id);
    //     socket.on("receiveMessage", (newMessage) => {
    //       const isSameDiscussion = String(newMessage.id_discussion) === String(discussionId);
    //       if (isSameDiscussion) {
    //         if (newMessage.id_sender !== currentUser._id) {
    //           showPush(newMessage);
    //           incrementTabBadge();
    //         }
    //         setMessages((prev) => [...prev, newMessage]);
    //       }
    //     });
    //     return () => {
    //       socket.off("receiveMessage");
    //       socket.emit("leaveDiscussion", discussionId);
    //       socket.disconnect();
    //     };
    //   }, [discussionId, socket]);

    //   const sendMessage = async (data) => {
    //     try {
    //       const res = await service.create(data);
    //       const message = res.data.data.message;
    //       socket.emit("sendMessage", {
    //         discussionId: data.id_discussion,
    //         ...message,
    //       });
    //       return message;
    //     } catch (err) {
    //       console.error("Erreur envoi message :", err);
    //     }
    //   };

    //   const sendMessageWithFiles = async (data) => {
    //     try {
    //       const res = await service.create(data);
    //       await markMessagesAsRead(data.id_discussion);
    //       const message = res.data.data.message;
    //       socket.emit("sendMessage", {
    //         discussionId: data.id_discussion,
    //         ...message,
    //       });
    //       return message;
    //     } catch (err) {
    //       console.error("Erreur envoi fichier:", err);
    //     }
    //   };

    //   const markMessagesAsRead = async (discussionId) => {
    //     try {      
    //       await service.markMessagesAsRead(discussionId, { userId: currentUser._id });
    //     } catch (err) {
    //       console.error("Erreur envoi message :", err);
    //     }
    //   };  
    const sendMessageMail = async (data) => {
        return service.sendMessageMail(data);
    };
    return {
        //     messages,
        //     setMessages,
        //     loadMessages,
        //     sendMessage,
        //     sendMessageWithFiles,
        //     resetTabBadge,
        //     markMessagesAsRead
        sendMessageMail
    };
}
